import React, { Fragment } from 'react'
import { AsyncTypeahead, Menu, MenuItem, Highlighter } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import lo from 'lodash'

const FormChipsSearch = ({
  placeholder,
  onChangeVal,
  options,
  onSearch,
  dispField,
  control,
  minLength,
  isLoading = false,
  ...props
}) => {
  const renderMenu = (results, menuProps, state) => {
    let index = 0;
    const group = lo.groupBy(results, (menus) => menus.section)
    const items = Object.keys(group).sort().map((section) => (
      <Fragment key={section}>
        {index !== 0 && <Menu.Divider />}
        <Menu.Header>{section}</Menu.Header>
        {group[section].map((cc) => {
          const item = (
            <MenuItem key={index} option={cc} position={index}>
              <Highlighter search={menuProps.text}>
                {cc[dispField]}
              </Highlighter>
            </MenuItem>
          );

          index += 1;
          return item;
        })}
      </Fragment>
    ));

    return <Menu {...menuProps}>{items}</Menu>;
  }
  const filterBy = () => true;

  return (
    <AsyncTypeahead
      id='multiple'
      clearButton
      multiple
      filterBy={filterBy}
      isLoading={isLoading}
      options={options || []}
      labelKey={dispField}
      placeholder={placeholder}
      selected={control}
      minLength={minLength}
      renderMenu={renderMenu}
      onSearch={e => onSearch(e)}
      onChange={e => onChangeVal(e)}
      {...props}
    />
  )
}

export default FormChipsSearch
